import { Waterbody, WaterbodyDetail } from '@omniafishing/core';
import classNames from 'classnames';
import React from 'react';
import { MapRef } from 'react-map-gl';
import { LoadingState } from '../../../../constants/loading_state';
import styles from './lakes_modal.less';
import { LakesModalDetailScreen } from './lakes_modal_detail_screen';
import { LakesModalListScreen } from './lakes_modal_list_screen';

interface LakesModalProps {
  waterbodiesLoadingState: LoadingState;
  isModalOpen: boolean;
  mapRef: MapRef;
  waterbodies: Waterbody[];
  onClose: () => void;
  waterbodySlug: string | null;
  waterbody: WaterbodyDetail | null;
  waterbodyLoadingState: LoadingState;
}

export const LakesModal = (props: LakesModalProps) => {
  const {
    waterbodiesLoadingState,
    isModalOpen,
    mapRef,
    waterbodies,
    onClose,
    waterbodySlug,
    waterbody,
    waterbodyLoadingState,
  } = props;

  const screens = {
    list: !waterbodySlug,
    details: !!waterbodySlug,
  };

  if (!isModalOpen) {
    return null;
  }

  return (
    <div className={classNames(styles.modal)}>
      {screens.list && (
        <LakesModalListScreen
          waterbodiesLoadingState={waterbodiesLoadingState}
          mapRef={mapRef}
          waterbodies={waterbodies}
          onClose={onClose}
        />
      )}
      {screens.details && (
        <LakesModalDetailScreen
          mapRef={mapRef}
          waterbodyLoadingState={waterbodyLoadingState}
          waterbody={waterbody}
          onClose={onClose}
          key={waterbodySlug}
        />
      )}
    </div>
  );
};
